import { gql } from '@apollo/client';

const USER_ALPHA_JOIN = gql`
  mutation UserAlphaJoin($input: UserAlphaJoinInput!) {
    userAlphaJoin(input: $input) {
      success
      message
    }
  }
`;

const USER_ALPHA_JOIN_VERIFY = gql`
  mutation UserAlphaJoinVerify($input: UserAlphaJoinVerifyInput!) {
    userAlphaJoinVerify(input: $input) {
      success
      token
      user {
        id
        email
      }
      message
    }
  }
`;

const USER_ALPHA_LOGIN = gql`
  mutation UserAlphaLogin($input: UserAlphaLoginInput!) {
    userAlphaLogin(input: $input) {
      success
      message
    }
  }
`;

const USER_ALPHA_LOGIN_VERIFY = gql`
  mutation UserAlphaLoginVerify($input: UserAlphaLoginVerifyInput!) {
    userAlphaLoginVerify(input: $input) {
      success
      token
      user {
        id
        email
      }
      message
    }
  }
`;

const DELETE_FOOTPRINT = gql`
  mutation DeleteFootprint($footprintId: String!) {
    footprintDelete(input: { footprintId: $footprintId }) {
      id
    }
  }
`;

const GET_FOOTPRINTS = gql`
  query GetFootprints {
    footprints {
      id
      title
      url
      createdAt
    }
  }
`;

const USER_PROFILE = gql`
  query UserProfile {
    userProfile {
      email
      handle
      memberSince
    }
  }
`;

const USER_USERNAME_VERIFY = gql`
  query UserUsernameVerify($input: UserUsernameVerifyInput!) {
    userUsernameVerify(input: $input) {
      available
    }
  }
`;

export {
  DELETE_FOOTPRINT,
  GET_FOOTPRINTS,
  USER_ALPHA_JOIN,
  USER_ALPHA_JOIN_VERIFY,
  USER_ALPHA_LOGIN,
  USER_ALPHA_LOGIN_VERIFY,
  USER_PROFILE,
  USER_USERNAME_VERIFY,
};
